import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import ChallengeCard from '../next_challenge/ChallengeCard';

const NextChallengeList = (props) => {
  const { repos, eventList, setEventList, remainEventList, setRemainEventList, handler } = props;
  const [showLayer, setShowLayer] = useState('hide');
  const [combineList, setCombineList] = useState([]);

  if (!repos || repos.length === 0)
    return <div className="no-data">Loading...</div>;

  const mergeList = (previousList, newList) => {
    const list = previousList ? [...previousList, ...newList] : newList;
    let idSet = new Set();
    const uniqueList = list.filter((item) => {
      let isUnique = false;
      if (!idSet.has(item)) {
        idSet.add(item);
        isUnique = true;
      }
      return isUnique;
    });
    return uniqueList;
  }

  const handleCombineList = () => {
    setCombineList(mergeList(combineList, repos))
    let tempList = []
    if (eventList !== null) {
      eventList.forEach(element => {
        if (
          element.start_date_time_ts > repos[repos.length - 1].start_date_time_ts
        ) {
          tempList.push(element)
          setEventList((current) =>
            current.filter((ele) => ele.id !== element.id)
          )
        }
      });
    }
    if (tempList.length > 0) {
      setCombineList(mergeList(combineList, tempList))
    }

  }

  useEffect(() => {
    handleCombineList()
    // EventEmitter.dispatch('show_prompt', {showPrompt: 'block'})
  }, [props])

  const getPrompt = (challenge) => {
    let sortedList = combineList.sort((a, b) => b.start_date_time_ts - a.start_date_time_ts)
    // EventEmitter.dispatch('show_prompt', {
    //   showPrompt: 'block',
    //   challenge: sortedList[0],
    //   promptType: NEW_CHALLENGE_PROMPT
    // })
  }

  return (
    <Container>
      {/* {combineList.sort((a, b) => b.start_date_time_ts - a.start_date_time_ts).map((repo, index) => { */}
      {repos.map((repo, index) => {
        // Have to find best way out for click event handling
        return (
          <Row
            className="justify-content-md-center challenge-list mt-4"
            key={index}
          >
            <ChallengeCard challenge={repo} handleClick={handler} />
            {/* <CompanionPrompt
              type={NEW_CHALLENGE_PROMPT}
              challenge={repo[0]}
            // showPrompt={showPrompt}
            // setShowPrompt={setShowPrompt}
            /> */}
            {/* {getPrompt()} */}
          </Row>
        );
      })}
      <Row className="justify-content-md-center mt-4 pb-5">
        <ChallengeCard type="guide" />
      </Row>
    </Container>
  );
};

export default NextChallengeList;
